export default __webpack_public_path__ + "static/media/IMG2861.df4c3001.jpg";